import Api from '@utils/api';
import { Aspirantes } from '@constants/urls';

export const state = {
	aspirantes: [],
	aspirante: {},
	filtro: '',
	loading: false,
	loading_action: false
};

export const getters = {
	getAspirantes(state) {
		return state.aspirantes;
	},
	getAspirante(state) {
		return state.aspirante;
	},
	getLoading(state) {
		return state.loading;
	},
	getLoadingAction(state) {
		return state.loading_action;
	}
};

export const mutations = {
	SET_ASPIRANTES(state, newValue) {
		state.aspirantes = newValue;
	},
	SET_ASPIRANTE(state, newValue) {
		state.aspirante = newValue;
	},
	SET_LOADING_FILES(state, newValue) {
		state.loading_action = newValue;
	},
	SET_FILTRO(state, newValue) {
		state.filtro = newValue;
	},
	SET_LOADING(state, newValue) {
		state.loading = newValue;
	}
};

export const actions = {
	inicializar({ commit }) {
		commit('SET_LOADING', true);
		Api.Get(Aspirantes.LISTAR)
			.then((response) => {
				commit('SET_ASPIRANTES', response.data.data);
			})
			.finally(() => {
				commit('SET_LOADING', false);
			});
	},
	limpiar({ commit }) {
		commit('SET_ASPIRANTES', []);
	},
	establecerAspirante({ commit }, aspirante) {
		commit('SET_ASPIRANTE', aspirante);
	},
	establecerFiltro({ commit }, { filtro }) {
		commit('SET_FILTRO', filtro);
	},
	subirArchivoCsv({ commit }, { archivos, onComplete, onError }) {
		commit('SET_LOADING_FILES', true);
		Api.PostFile(Aspirantes.IMPORTAR, archivos)
			.then(onComplete)
			.catch(onError)
			.finally(() => setTimeout(() => commit('SET_LOADING_FILES', false), 400));
	},
	//				Notification('success', 'Usuario eliminados correctamente');
	eliminarTodos({ commit }, { onComplete, onError }) {
		commit('SET_LOADING_FILES', true);
		Api.Delete(Aspirantes.ELIMINAR_TODOS)
			.then(onComplete)
			.catch(onError)
			.finally(() => setTimeout(() => commit('SET_LOADING_FILES', false), 400));
	},
	obtenerElemento({ commit }, { elemento, onComplete, onError }) {
		commit('SET_LOADING', true);
		Api.Get(Aspirantes.OBTENER(elemento.ficha))
			.then(onComplete)
			.catch(onError)
			.finally(() => commit('SET_LOADING', false));
	},
	bloquearAlAspirante({ commit }, { folio, onComplete, onError }) {
		commit('SET_LOADING', true);
		Api.Post(Aspirantes.BLOQUEAR(folio))
			.then(onComplete)
			.catch(onError)
			.finally(() => commit('SET_LOADING', false));
	},
	desbloquearAlAspirante({ commit }, { folio, onComplete, onError }) {
		commit('SET_LOADING', true);
		Api.Post(Aspirantes.DESBLOQUEAR(folio))
			.then(onComplete)
			.catch(onError)
			.finally(() => commit('SET_LOADING', false));
	},
	crearAspirante({ commit }, { params, onComplete, onError }) {
		commit('SET_LOADING_FILES', true);
		Api.Post(Aspirantes.CREAR, params)
			.then(onComplete)
			.catch(onError)
			.finally(() => setTimeout(() => commit('SET_LOADING_FILES', false), 400));
	},
	editarAspirante({ commit }, { ficha, params, onComplete, onError }) {
		commit('SET_LOADING_FILES', true);
		Api.Put(Aspirantes.EDITAR(ficha), params)
			.then(onComplete)
			.catch(onError)
			.finally(() => setTimeout(() => commit('SET_LOADING_FILES', false), 400));
	},
	restablecerContraseniaAspirante(
		{ commit },
		{ ficha, params, onComplete, onError }
	) {
		commit('SET_LOADING_FILES', true);
		Api.Put(Aspirantes.RESTABLECER_CONTRASENIA(ficha), params)
			.then(onComplete)
			.catch(onError)
			.finally(() => setTimeout(() => commit('SET_LOADING_FILES', false), 400));
	},
	eliminarAspirante({ commit }, { ficha, params, onComplete, onError }) {
		commit('SET_LOADING_FILES', true);
		Api.Delete(Aspirantes.ELIMINAR(ficha), params)
			.then(onComplete)
			.catch(onError)
			.finally(() => setTimeout(() => commit('SET_LOADING_FILES', false), 400));
	}
};
